import { makeObservable, observable, flow, action } from "mobx";
import { api } from "@/lib/services";

import UpdateSubscriberSchema from "@/areas/subscriptions/schemas/UpdateSubscriberSchema";
import {
  beginSubscriberToast,
  completeSubscriberToast,
  failSubscriberToast,
} from "@/areas/subscriptions/components/subscribers/subscriberToast";

export default class UpdateSubscriberStore {
  visible = false;
  processing = false;
  subscriber = null;

  constructor(parentStore, apiPrefix) {
    makeObservable(this, {
      visible: observable,
      processing: observable,
      subscriber: observable,
      show: action,
      hide: action,
      toggle: action,
      save: flow,
    });

    this.parentStore = parentStore;
    this.apiPrefix = apiPrefix;
  }

  show(subscriber) {
    this.visible = true;
    this.subscriber = subscriber;
  }

  hide() {
    this.visible = false;
    this.subscriber = null;
  }

  toggle(visible) {
    this.visible = visible === true ? true : visible === false ? false : !this.visible;
    if (!this.visible) {
      this.subscriber = null;
    }
  }

  *save(data, options) {
    let toastId;
    try {
      this.processing = true;
      const parseResult = UpdateSubscriberSchema.safeParse(data);
      if (!parseResult.success) {
        return parseResult;
      }

      toastId = beginSubscriberToast({
        user: data.user,
        roles: data.subscriptions,
        message: "Updating roles to",
      });

      const response = yield api.post(`${this.apiPrefix}/subscribers`, data);
      this.visible = false;

      completeSubscriberToast({
        toastId,
        user: data.user,
        roles: data.subscriptions,
        message: "Roles updated to",
      });

      this.parentStore.browseSubscribersStore.load({ search: "", page: 1 });
      return { success: true, data: response.data };
    } catch (e) {
      failSubscriberToast({
        toastId,
        message: "Error while updating subscriber",
        description: e.message,
      });
      return { success: false, error: e };
    } finally {
      this.processing = false;
    }
  }
}
